import { Component } from '@angular/core';

import { ProductService } from '@app/services/product.service';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent {
  title = 'dbm';

}
